import { feberApiDelete, feberApiGet, feberApiPost, feberApiPut } from '../../../../../services/commonServices';
import { IFeature, IFeaturePermission } from './types';

// API service functions (to be implemented with actual API calls)

export const getAllFeaturesService = async (): Promise<IFeature[]> => {
    try {
        return await feberApiGet<IFeature[]>("Configuration/GetAllAvailableFeatures");
    } catch (error: any) {
        console.error("Failed to get all roles:", error);
        throw error;
    }
};

export const createFeatureService = async (feature: IFeature): Promise<IFeature> => {
    try {
        return await feberApiPost<IFeature>("Configuration/AddFeature", feature);
    } catch (error: any) {
        console.error("Failed to create feature:", error);
        throw error;
    }
};

export const updateFeatureService = async (feature: IFeature): Promise<IFeature> => {
    try {
        return await feberApiPut<IFeature>("Configuration/UpdateFeature", feature);
    } catch (error: any) {
        console.error("Failed to update feature:", error);
        throw error;
    }
};

export const deleteFeatureService = async (featureIds: number[]): Promise<boolean> => {
    try {
        return await feberApiDelete<boolean>("Configuration/DeleteFeature", { featureIds });
    } catch (error: any) {
        console.error("Failed to delete feature:", error);
        throw error;
    }
};

// Feature Permissions Services

export const getFeaturePermissionService = async (featureId: number): Promise<IFeaturePermission> => {
    try {
        return await feberApiGet<IFeaturePermission>("Configuration/GetFeaturePermissionById", { featureId });
    } catch (error: any) {
        console.error("Failed to get feature permission:", error);
        throw error;
    }
};

export const addFeaturePermissionService = async (payload: IFeaturePermission): Promise<IFeaturePermission> => {
    try {
        return await feberApiPost<IFeaturePermission>("Configuration/AddFeaturePermission", payload);
    } catch (error: any) {
        console.error("Failed to add feature permission:", error);
        throw error;
    }
};

export const updateFeaturePermissionService = async (payload: IFeaturePermission): Promise<IFeaturePermission> => {
    try {
        return await feberApiPut<IFeaturePermission>("Configuration/UpdateFeaturePermission", payload);
    } catch (error: any) {
        console.error("Failed to update feature permission:", error);
        throw error;
    }
};

